"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const SubNav_module_css_1 = __importDefault(require("./styles/SubNav.module.css"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const reduxHooks_1 = require("src/hooks/reduxHooks");
const utils_1 = require("src/utils/utils");
const sharedUtils_1 = require("src/utils/sharedUtils");
const selectors_1 = require("src/stores/applicationStore/auth/selectors");
const SubNav = ({ navItems }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    (0, react_1.useEffect)(() => {
        const subRoutes = navItems.map((v) => v.value);
        for (const route of subRoutes) {
            if ((0, utils_1.isActiveRoute)(route, location.pathname)) {
                return;
            }
        }
        navigate(navItems[0].value, { replace: true });
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Navbar, Object.assign({ className: "p-0" }, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Navbar.Collapse, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Navbar, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Nav, Object.assign({ className: "d-flex flex-column" }, { children: navItems.map((section) => {
                        return (0, sharedUtils_1.access)({
                            profile: me,
                            section: section.permission,
                            permission: "view",
                        }) ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Nav.Link, Object.assign({ active: (0, utils_1.isActiveRoute)(section.value, location.pathname), as: react_router_dom_1.Link, to: section.value, className: SubNav_module_css_1.default.link }, { children: i18n_1.default.t(section.label) }), section.value)) : null;
                    }) })) }) }) })));
};
exports.default = SubNav;
